<template>
  <div class="form-group">
    <label :for="id" class="form-label">{{ label }}</label>
    <input
      :id="id"
      type="number"
      class="form-control"
      :min="minValue"
      :max="maxValue"
      :placeholder="placeholder"
      v-model="localValue"
    />
    <slot name="validation"></slot>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Number,
      required: true,
    },
    minValue: {
      type: Number,
      required: false,
    },
    maxValue: {
      type: Number,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      backingValue: null,
    };
  },
  computed: {
    localValue: {
      get: function() {
        return this.backingValue || this.modelValue;
      },
      set: function(value) {
        if (value) {
          const nValue = parseFloat(value);
          this.backingValue = nValue;
          this.$emit("update:modelValue", nValue);
        } else {
          this.$emit("update:modelValue", value);
        }
      },
    },
  },
};
</script>
